import { render, staticRenderFns } from "./NotificationGroup.vue?vue&type=template&id=1e96344f&scoped=true&"
import script from "./NotificationGroup.vue?vue&type=script&lang=js&"
export * from "./NotificationGroup.vue?vue&type=script&lang=js&"
import style0 from "./NotificationGroup.vue?vue&type=style&index=0&id=1e96344f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e96344f",
  null
  
)

export default component.exports